import React, { useState, useContext, useEffect } from 'react';
import { array } from 'prop-types';
import classNames from 'classnames/bind';

import OeNumbersTable from '../OeNumbersTable';
import SelectBrand from '../SelectBrand';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import { StaticTextContext } from 'context/StaticTextContext';

import styles from './TabOeNumbers.module.scss';
const cx = classNames.bind(styles);

const TabOeNumbers = ({ dataOeNumbers }) => {
  const [currentBrand, setCurrentBrand] = useState();
  const { labels } = useContext(StaticTextContext);

  useEffect(() => {
    // We remove min-height style to prevent jumping tabs on click.
    document.getElementById('product-tabs') &&
      document.getElementById('product-tabs').removeAttribute('style');
  }, []);

  return (
    <div className={cx('tab-content')}>
      <SelectBrand
        setCurrentBrand={setCurrentBrand}
        dataOeNumbers={dataOeNumbers}
      />
      <h3 className={cx('title')}>{labels.oeNumbersLabel}</h3>
      {currentBrand && <OeNumbersTable data={currentBrand.models} />}
    </div>
  );
};

TabOeNumbers.propTypes = {
  dataOeNumbers: array.isRequired,
};

export default withErrorBoundary(TabOeNumbers);



// WEBPACK FOOTER //
// ./src/pages/Product/components/TabOeNumbers/TabOeNumbers.js